// extracted by mini-css-extract-plugin
export var label = "_aq-5";
export var slideContainer = "_aq-0";
export var slider = "_aq-1";
export var sliderLg = "_aq-4";
export var sliderMd = "_aq-3";
export var sliderSm = "_aq-2";